var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"play-bar"},[_c('h2',[_vm._v(_vm._s(_vm.currentDrama.title))]),(_vm.currentDrama.audioUrl)?_c('audio',{attrs:{"controls":"","src":_vm.currentDrama.audioUrl}},[_vm._v(" 您的浏览器不支持音频播放。 ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }